const getArchiveIdByPostType = postType => {
    if (!postType) return false
    const archives = WPVUE.archives
    return (archives && archives[postType]) ? Number(archives[postType].id) : Number(WPVUE.post_page_id)
}

const getFrontPageID = () => Number(WPVUE.front_page)

const postTypeForRest = postType => (postType === 'post' || postType === 'page') ? postType + 's' : postType

export { getArchiveIdByPostType, getFrontPageID, postTypeForRest }